import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export function PrivacyPolicy() {
  return (
    <div className="min-h-screen pt-[132px] pb-20 px-4 md:px-8 bg-[#050505] text-white">
      <div className="max-w-3xl mx-auto">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-zinc-400 hover:text-teal-400 text-sm mb-10 transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to home
        </Link>
        <h1 className="font-heading text-4xl md:text-5xl font-black uppercase tracking-tight mb-2">Privacy Policy</h1>
        <p className="text-zinc-500 text-sm mb-10">Last updated: March 2026</p>

        <div className="space-y-8 text-zinc-300 text-sm leading-relaxed">
          <section>
            <h2 className="font-heading text-lg font-bold text-white uppercase tracking-wide mb-3">Who we are</h2>
            <p>
              <strong className="text-white">SprintFit</strong> is the brand that runs this site, fulfilment, and checkout
              (including <a href="https://shop.sprintfit.in" className="text-teal-400 hover:underline" target="_blank" rel="noopener noreferrer">shop.sprintfit.in</a>
              ). <strong className="text-white">ThermaCube</strong> is a SprintFit product line (wearable contrast therapy); we may add
              other SprintFit products over time. Questions about this policy:{' '}
              <a href="mailto:support@sprintfit.in" className="text-teal-400 hover:underline">
                support@sprintfit.in
              </a>
              .
            </p>
          </section>
          <section>
            <h2 className="font-heading text-lg font-bold text-white uppercase tracking-wide mb-3">Information we collect</h2>
            <p>
              We may collect information you provide when you contact us, place an order, or sign up for updates — such as
              name, email, phone number, and shipping address. We also collect standard technical data (e.g. browser type,
              pages visited) to run and improve the site.
            </p>
          </section>
          <section>
            <h2 className="font-heading text-lg font-bold text-white uppercase tracking-wide mb-3">How we use it</h2>
            <p>
              We use your information to process orders, provide support, communicate about your purchase, and improve our
              products and website. We do not sell your personal information. Service providers (e.g. payment and shipping
              partners) may process data only as needed to perform their services.
            </p>
          </section>
          <section>
            <h2 className="font-heading text-lg font-bold text-white uppercase tracking-wide mb-3">Cookies</h2>
            <p>
              We may use cookies or similar technologies for essential site function, preferences, and analytics. You can
              control cookies through your browser settings.
            </p>
          </section>
          <section>
            <h2 className="font-heading text-lg font-bold text-white uppercase tracking-wide mb-3">Your choices</h2>
            <p>
              You may request access, correction, or deletion of your personal data where applicable by emailing{' '}
              <a href="mailto:support@sprintfit.in" className="text-teal-400 hover:underline">
                support@sprintfit.in
              </a>
              . We will respond within a reasonable time.
            </p>
          </section>
          <section>
            <h2 className="font-heading text-lg font-bold text-white uppercase tracking-wide mb-3">Changes</h2>
            <p>We may update this policy from time to time. The &quot;Last updated&quot; date at the top will change when we do.</p>
          </section>
          <p className="text-zinc-500 text-xs pt-4 border-t border-white/10">
            This page is a general summary and not legal advice. For specific concerns, consult a qualified professional.
          </p>
        </div>
      </div>
    </div>
  );
}
